exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n[data-v-9ff4ff38] .primary-color {\n  color: #00afa1;\n}\n[data-v-9ff4ff38] .text-center {\n  text-align: center;\n}", ""]);

// exports
